import { render, staticRenderFns } from "./SettingsModuleBase.vue?vue&type=template&id=1ccf55ae&scoped=true&"
import script from "./SettingsModuleBase.vue?vue&type=script&lang=ts&"
export * from "./SettingsModuleBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf55ae",
  null
  
)

export default component.exports